import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box } from '@mui/material';
import React from 'react';
import './BottomNav.css';

const NAVY = '#0b2447';
const NAVY_DEEP = '#061a36';
const ACCENT = '#ef6a1d';

const items = [
  {
    href: 'tel:+919510980382',
    label: 'Call',
    Icon: PhoneIcon,
    color: '#22c55e',
    colorRgb: '34,197,94',
  },
  {
    href: 'mailto:admin@realstockexperts.in',
    label: 'Email',
    Icon: EmailIcon,
    color: '#3b82f6',
    colorRgb: '59,130,246',
  },
  {
    href: 'https://wa.me/+919213647646',
    label: 'WhatsApp',
    Icon: WhatsAppIcon,
    color: '#25d366',
    colorRgb: '37,211,102',
    external: true,
  },
];

const BottomNav = () => {
  return (
    <Box
      className="rs-bottom-nav"
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1400,
        display: { xs: 'flex', md: 'none' },
        justifyContent: 'space-around',
        alignItems: 'center',
        gap: 1,
        px: 1.2,
        pt: 1.4,
        pb: 'calc(1rem + env(safe-area-inset-bottom, 0px))',
        background: `linear-gradient(180deg, ${NAVY} 0%, ${NAVY_DEEP} 100%)`,
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        boxShadow: '0 -12px 32px rgba(6,26,54,0.35)',
        /* Top accent stripe */
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '20%',
          right: '20%',
          height: 3,
          borderRadius: 2,
          background: `linear-gradient(90deg, transparent 0%, ${ACCENT} 50%, transparent 100%)`,
        },
      }}
    >
      {items.map(({ href, label, Icon, color, colorRgb, external }) => (
        <Box
          key={label}
          component="a"
          href={href}
          {...(external
            ? { target: '_blank', rel: 'noopener noreferrer' }
            : {})}
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.5,
            py: 0.5,
            textDecoration: 'none',
            color: '#cbd5e1',
            transition: 'all 0.25s ease',
            WebkitTapHighlightColor: 'transparent',
            '& .bn-icon': {
              transition: 'all 0.25s ease',
            },
            '&:hover, &:active': {
              color: '#fff',
              transform: 'translateY(-2px)',
            },
            '&:hover .bn-icon, &:active .bn-icon': {
              background: color,
              borderColor: color,
              boxShadow: `0 10px 22px rgba(${colorRgb}, 0.45)`,
              '& svg': { color: '#fff' },
            },
          }}
        >
          <Box
            className="bn-icon"
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `rgba(${colorRgb}, 0.14)`,
              border: `1px solid rgba(${colorRgb}, 0.4)`,
              '& svg': {
                fontSize: '1.25rem',
                color,
                transition: 'color 0.25s ease',
              },
            }}
          >
            <Icon />
          </Box>
          <Box
            sx={{
              fontSize: '0.72rem',
              fontWeight: 600,
              letterSpacing: 0.3,
            }}
          >
            {label}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default BottomNav;
